import React, { ReactNode } from 'react';
import { Label } from './Label';
import { DiscountPill } from '../../Common/DiscountPill';
import cx from 'classnames';

export interface PricePanelProps {
  discountLabel?: string;
  priceLabel?: ReactNode;
}

export function PricePanel({ discountLabel, priceLabel }: PricePanelProps) {
  return (
    <div className='flex flex-col gap-y-4 items-end'>
      <Label>Price/mo</Label>
      <div className='flex flex-row gap-x-4 items-center flex-wrap text-center justify-end'>
        {discountLabel && (
          <DiscountPill label={`${discountLabel} off applied`} />
        )}
        <span
          className={cx('text-[21px]', {
            'v2-text-neutral-500': discountLabel,
            'v2-text-neutral-900': !discountLabel,
          })}
        >
          {priceLabel}
        </span>
      </div>
    </div>
  );
}
